import { render, staticRenderFns } from "./main.vue?vue&type=template&id=d0cee464&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.vue?vue&type=style&index=0&id=d0cee464&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0cee464",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0cee464')) {
      api.createRecord('d0cee464', component.options)
    } else {
      api.reload('d0cee464', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=d0cee464&scoped=true", function () {
      api.rerender('d0cee464', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/manager-form/components/prize-serial-code/main.vue"
export default component.exports